export default "__VITE_ASSET__CdKqxixG__"